<template>
  <div v-if="getRoot" class="page">
    <Header />
    <main class="main">
      <Menu />

      <div class="content-page">
        <div class="content-main">
          <router-view />
        </div>
        <div
          v-if="!$route.meta.fullWidth"
          class="content-promo"
        >
          <Chat />
        </div>
      </div>

      <div
        v-if="scroll"
        class="back-to-top js-back-to-top shown"
        @click="scrollTop"
      >
        Вверх
      </div>
    </main>
  </div>

  <!-- <Login v-else-if="getNewUser" /> -->

  <NewUser v-else-if="getNewUser" />

  <Login v-else />
</template>

<script>
import Header from "@/component/header";
import Menu from "@/component/menu";
import Login from "./login/LoginPage.vue";
import NewUser from "./login/NewUser.vue";

import Chat from "@/component/chat";

import { mapGetters } from "vuex";

export default {
  data() {
    return {
      scroll: false,
    };
  },
  components: {
    Header,
    Menu,
    Login,
    NewUser,
    Chat,
  },
  created() {
    addEventListener("scroll", (event) => {
      this.scroll = window.scrollY >= 700;
    });
  },
  computed: {
    ...mapGetters({
      getRoot: "main/getRoot",
      getNewUser: "main/getNewUser",
    }),
  },
  methods: {
    scrollTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>